import React, { useState } from 'react';

import {
  Card,
  Input,
  IconButton,
  Button,
  Tooltip,
  ListItem,
  ListItemPrefix,
  ListItemSuffix,

} from "@material-tailwind/react";
import {
  MapIcon,
  MagnifyingGlassIcon,
  PencilSquareIcon,
  UserPlusIcon,
  UserIcon,
  BriefcaseIcon,
  PaperClipIcon,

} from "@heroicons/react/24/outline";

import * as turf from '@turf/turf';

import ClientCard from './ClientCard';
import CompanyCard from './CompanyCard';
import { getFields, getFieldsInfo } from './AdminTools';
import { getExamExpiry, getDateDiff, getExamTime, getExamValue } from "./ExamTools";

export default function ClientsList(props) {
  const [clients, setClients] = useState(localStorage.getItem("clients") || []);
  const [clientid, setClientId] = useState(0);
  const [masterid, setMasterId] = useState(0);
  const [search, setSearch] = useState('');
  const [authenticated, setAuthenticated] = useState(localStorage.getItem("authenticated") || false);
  const [session, setSession] = useState(localStorage.getItem("session") || null);
  const [failed, setFailed] = useState(false);
  const [message, setMessage] = useState('');
  const [showClient, setShowClient] = useState(false);
  const [showCompany, setShowCompany] = useState(false);
  const [clientFieldsFC, setClientFieldsFC] = useState();

  React.useEffect(() => {
    getClients();
  }, []);


  function getClients() {
    var bodydata = JSON.stringify({ action: 'clients', session: session });

    fetch('https://online.mysoil.pl/cgi-bin/user.py', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: bodydata,
      mode: 'cors'

    })
      .then(res => res.json())
      .then(data => { setClients(data.clients); localStorage.setItem("clients", JSON.stringify(data.clients)); })
  }


  const showClientCard = (e) => {
    const id = e.currentTarget.getAttribute("data-clientid");
    setClientId(id);
    setShowClient(showClient === true ? false : true);
  };



  function showClientOrCompanyCard(e) {
    const id = e.currentTarget.getAttribute("data-clientid");
    setClientId(id);
    const master = e.currentTarget.getAttribute("data-master");
    if (master > 0) {
      //company
      setMasterId(master);
      setShowCompany(showCompany === true ? false : true);
    }
    else {
      //client
      setShowClient(showClient === true ? false : true);
    }

  }


  function resizeBoundingBox(bounds) {
    var point1 = turf.point([bounds[0], bounds[1]]);
    var point2 = turf.point([bounds[2], bounds[3]]);
    var bearing = turf.bearing(point1, point2);
    var distance = turf.distance(point1, point2);
    var p1 = turf.destination(point1, -0.2 * distance, bearing);
    var p2 = turf.destination(point2, 0.2 * distance, bearing);
    var box = [p1.geometry.coordinates[0], p1.geometry.coordinates[1], p2.geometry.coordinates[0], p2.geometry.coordinates[1]];
    return box;
  }


  function applyFeatureCollection(collection) {
    localStorage.setItem('featureCollection', JSON.stringify(collection));
    dispatchEvent(new Event("featureCollectionChanged"));
  }

  function applyClientFeaturesOnMap(owner) {
    localStorage.setItem('clientFeaturesOnMap', owner);
  }


  function applyBoundingBox(bounds) {
    localStorage.setItem('boundingBox', JSON.stringify(bounds));
    dispatchEvent(new CustomEvent('boundingBoxChanged', { detail: bounds })); //cool can pass arguments in event this way
  }






  function buildFeatureCollection(fields) {
    let newfc = {
      type: "FeatureCollection",
      features: []
    }

    console.log("build FC in client list")  ;
    fields.forEach(field => {
      let fieldshape = JSON.parse(field.shape);
      if (field.selected == true) {
        fieldshape.features.forEach(feature => {
          //feature.properties.value=1;  
          feature.properties.fieldid = field.id;
          feature.properties.value = getExamValue(feature.examtime); //feature.examined
          feature.properties.polygonName=getExamExpiry(feature.examtime); //feature.examined
          newfc.features.push(feature);
        });
      }
    });

    //console.log("newfc.feat.len " + newfc.features.length);
    if (newfc.features.length == 0) {
      fields.forEach(field => {
        let fieldshape = JSON.parse(field.shape);
        fieldshape.features.forEach(feature => {
          feature.properties.fieldid = field.id;
          feature.properties.value = getExamValue(feature.examtime); //feature.examined
          feature.properties.polygonName=getExamExpiry(feature.examtime); //feature.examined
          newfc.features.push(feature);
        });
      }
      );
    }
    setClientFieldsFC(newfc);
    showGeoJson(newfc, true);
  }



  function showGeoJson(feature, refresh) {
    if (!feature) return;

    let collection;
    try {
      if (feature.type == "FeatureCollection") {
        collection = feature;
      }
      else if (feature.type == "Feature") {
        collection = {
          "type": "FeatureCollection",
          features: [feature]
        }
      }
    } catch { console.log('unknown feature type'); }

    if (collection.features.length == 0) {
      console.log('No features to display');
      return;
    }

    //console.log('Featrue Collection ready to display');
    //console.log(collection);
    //setFeaturesCount(collection.features.length);
    //set value based on examined.timestamp



    //console.log('Featrue Collection with colors');
    //console.log(collection);

    let area = turf.area(feature) / 10000.0;
    let bounds = turf.bbox(feature);
    let center = turf.center(feature);
    let resizedbounds = resizeBoundingBox(bounds);

    //grid(resizedbounds, collection);
    //gridtest(resizedbounds, collection);

    applyFeatureCollection(collection);
    applyBoundingBox(resizedbounds);


  }



  const selectClient = (e) => {
    const id = e.currentTarget.getAttribute("data-clientid");
    setClientId(id);
    props.onSelect(id);
    getFields(session, buildFeatureCollection, id);
    getFieldsInfo(session, () => void 0, id);
    applyClientFeaturesOnMap(id);

  };




  function ClientItem(props) {
    let tip = "Wybierz klienta do kontekstu"
    let edittip = "Edytuj dane klienta"
    let filetip = "Pokaż pliki powiazane z klientem"
    let master = 0;
    if (props.master > 0) {
      tip = "Wybierz spółkę do kontekstu";
      edittip = "Edytuj dane spółki"
      filetip = "Pokaż pliki powiazane ze spółką"
      master = props.master;
    }



    return (
      <div className='flex flex-row ml-0'>
        <ListItem className="h-10 " key={props.id} data-clientid={props.id} onClick={selectClient}>
          <ListItemPrefix className='px-0 mr-2 ml-0'>
            {master == 0 && <Tooltip content={tip}>
              <UserIcon className='h-[18px] w-[18px]' />
            </Tooltip>
            }
            {master > 0 && <Tooltip content={tip}>
              <BriefcaseIcon className='h-[18px] w-[18px]' />
            </Tooltip>
            }

          </ListItemPrefix>
          <Tooltip content={props.name}>
            <span className='text-xs text-left  line-clamp-2'>{props.name}</span>
          </Tooltip>
          <ListItemSuffix>
            <Tooltip content={tip}>
              <span className='ml-auto mr-0 text-xs text-center capitalise w-[3rem]'>{props.city}</span>
            </Tooltip>
          </ListItemSuffix>
        </ListItem>
        <Tooltip content={edittip}>
          <IconButton size="sm" variant='outlined' className='mt-1 px-2' color="blue" data-clientid={props.id} data-master={master} onClick={showClientOrCompanyCard}>
            <PencilSquareIcon className='w-4 h-4' />
          </IconButton>
        </Tooltip>
        <Tooltip content={filetip}>
          <IconButton size="sm" variant='outlined' className='mt-1 ml-1 px-2' color="purple" data-clientid={props.id} data-master={master} onClick={showClientOrCompanyCard}>
            <PaperClipIcon className='w-4 h-4' />
          </IconButton>
        </Tooltip>

      </div>
    )
  }

  /**
    </div>
  
        <div className="flex items-center justify-between gap-1 w-auto my-1">
          <div>
            <Button size="sm" variant='text' className='w-[14rem] text-left text-slate-800 normal-case'>{props.name}</Button>
            <Tooltip content="Edytuj dane klienta">
            <IconButton size="sm" variant='text' className='' color="blue-gray" data-clientid={props.id} onClick={showClientCard}>
              <PencilSquareIcon className='w-6 h-6' />
            </IconButton>
            </Tooltip>
            <Tooltip content="Pokaż pola klienta">
            <IconButton size="sm" variant='text' className='' color="blue-gray" >
              <MapIcon className='w-6 h-6' />
            </IconButton>
            </Tooltip>
          </div>
        </div>
   
  * 
   * @param {*} refresh 
   */

  function hideClientCard(refresh) {
    setShowClient(false);
    if (refresh == true) getClients();
  }
  function hideCompanyCard(refresh) {
    setShowCompany(false);
    if (refresh == true) getClients();
  }


  function RenderClientList() {
    var select = [];
    var lsearch = search.toLowerCase();

    if (search.length == 0 || search == '') { select = clients; }
    else if (search.length == 1) { select = clients.filter(c => c.name.toLowerCase().startsWith(lsearch)); }
    else { select = clients.filter(c => c.name.toLowerCase().includes(lsearch)); }

    if (Array.isArray(select)) {
      return (
        select.map((client) => (
          <ClientItem name={client.name} id={client.id} city={client.city} master={client.master} />
        )
        ))
    }
  }



  return (
    <>
      <Card className={`absolute h-[calc(100vh-2rem)] w-full max-w-[22rem] pl-0 pr-2 shadow-xl top-[1rem] lg:left-[17rem] left-[6rem] z-10 overflow-y-auto ${showClient == true ? 'opacity-75' : 'opacity-100'}`}>
        <div className="mb-2 p-2 flex mx-auto">
          <Input label="Szukaj" onChange={e => setSearch(e.target.value)} />
          <MagnifyingGlassIcon className='relative right-7 top-2 h-6 w-6 text-blue-500' />
          <Tooltip content="Dodaj klienta">
            <IconButton size="md" variant="gradient" className='px-4' color="green" data-clientid={0} onClick={showClientCard} >
              <UserPlusIcon className='w-5 h-5' color="white" strokeWidth={2} />
            </IconButton>
          </Tooltip>
        </div>
        <RenderClientList />
      </Card>
      {showClient === true ? <ClientCard close={hideClientCard} id={clientid} /> : ''}
      {showCompany === true ? <CompanyCard close={hideCompanyCard} id={clientid} master={masterid} /> : ''}
    </>
  );
}

